import { defineStore } from "pinia";
import { ref } from "vue";
import { API } from "@/queries/index";
import { AxiosError } from "axios";
import { APIResponse, APIResponseError } from "@/types/api";
import { handleResponse, handleResponseError } from "@/utils/api";
import { UserPICDataPayload, UserPICDataResponse } from "@/types/interface/user-pic";

export const userUserPicStore = defineStore("userPicStore", () => {
  const userPic = ref<UserPICDataResponse>();
  const userPics = ref<UserPICDataResponse[]>([]);

  function initUserPics(data: any) {
    userPics.value = data?.data;
  }

  function addNewPic(data: any) {
    userPic.value = data;
  }

  async function dispatchGetAll(page = 1, limit = 10, queryParam = "") : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.userPic.getUserPic(page, limit, queryParam);
      if (status === 200 ) {
        initUserPics(data);
        return handleResponse(status, data);
      }
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
    return handleResponse(200, null);
  }

  async function dispatchDetail(idUserPic = "") : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.userPic.findUserPic(idUserPic);
      if (status === 200 ) {
        addNewPic(data);
        return handleResponse(status, data);
      }
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
    return handleResponse(200, null);
  }

  async function dispatchCreate(payload: UserPICDataPayload) : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.userPic.createUserPic(payload);
      if (status === 200 ) {
        addNewPic(data);
        return handleResponse(status, data);
      }
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
    return handleResponse(200, null);
  }

  async function dispatchUpdate(idUserPic = "", payload: UserPICDataPayload) : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.userPic.updateUserPic(idUserPic, payload);
      if (status === 200 ) {
        addNewPic(data);
        return handleResponse(status, data);
      }
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
    return handleResponse(200, null);
  }

  async function dispatchDelete(idUserPic = "") : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.userPic.deleteUserPic(idUserPic);
      if (status === 200 ) {
        return handleResponse(status, data);
      }
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
    return handleResponse(200, null);
  }

  return {
    userPic,
    userPics,
    initUserPics,
    dispatchCreate,
    dispatchUpdate,
    dispatchDetail,
    dispatchGetAll,
    dispatchDelete
  };
});